import { render, staticRenderFns } from "./PropertyAttention.vue?vue&type=template&id=87dc442a&scoped=true&"
import script from "./PropertyAttention.vue?vue&type=script&lang=js&"
export * from "./PropertyAttention.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAttention.vue?vue&type=style&index=0&id=87dc442a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc442a",
  null
  
)

export default component.exports